    <div class="login-body">

        <img class="login-image animated fadeIn" src="../../../assets/am-servicios-logo-navbar.png">
        <button class="login-button" type="button" (click)="login()"> Iniciar sesión <i class="fas fa-sign-in-alt"></i></button>
    </div>